import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Spettacolo } from '../../../../shared/interface';

@Component({
  selector: 'app-immagini-spettacolo-backoffice',
  templateUrl: './immagini-spettacolo-backoffice.component.html',
  styleUrl: './immagini-spettacolo-backoffice.component.css',
})
export class ImmaginiSpettacoloBackofficeComponent {

  @Input() spettacolo?: Spettacolo;
  @Output() ritaglio = new EventEmitter<{img_box: string, img_home: string, img_cover: string}>();

  add: boolean = false;  
  
  img_box: string = '';
  img_home: string = '';
  img_cover: string = '';
  tipo: string = '';
  
  onCarica(tipo: string) {
    this.tipo = tipo;
    this.add = true;
  }

  onRitaglio(immagine: string) {    
    if (this.tipo == 'box')
      this.img_box = immagine;
    else if (this.tipo == 'home')
      this.img_home = immagine;
    else
      this.img_cover = immagine;
  }

  onConferma() {
    this.add = false;
    this.ritaglio.emit({img_box: this.img_box, img_home: this.img_home, img_cover: this.img_cover});
  }
}
